import LegalPage from "../components/LegalPage";
import { COOKIE_SECTIONS, GALLERY } from "../data/content";

const CookiePolicy = () => (
  <LegalPage
    testId="cookie-page"
    path="/cookie-policy"
    seoTitle="Cookie Policy"
    seoDescription="What BTK Mortgage Services stores on your device and how to control it. Strictly necessary cookies only — no advertising or cross-site tracking."
    eyebrow="Legal · Cookies"
    title="Cookie policy."
    italic="The small print on crumbs."
    intro="What this site stores on your device and how to control it. Nothing fancy, nothing sold on."
    image={GALLERY[3]}
    sections={COOKIE_SECTIONS}
  />
);

export default CookiePolicy;
